export enum ExtraOption {
    TIRE_PACKAGE_PLUS = 'tire-package-plus',
    REMOVE_BRANDING = 'remove-branding',
    WARRANTY_ASSISTANCE = 'warranty-assistance',
    BISECT_RETENTION = 'bisect-retention',
}
